// src/com/trans_plan_travel/TransPlanTravelGql.js
import { gql } from "@apollo/client";
import IsValid from "../../value/IsValid";

/*

type TransPlanTravel {
    planId: String
    planDate: String
    dcCd: String
    dcName: String
    comId: String
    comName: String
    vehPlates: String
    bindGroupNo: Int
    bindOrder: Int
    driverName: String
    driverMobile: String
    rentYn: String
    timeDeparture: String
    storeId: String
    storeName: String
    hocha: Int
    prosDptrTime: String
    prosArrTime: String
    timeArrival: String
    dischStartKeyTime: String
    storeKeyDptrTime: String
    regDate: String
    regUser: String
}

extend type Query {
    transPlanTravelList(planDate:String!, dcCd:String): [TransPlanTravel]!
}
*/

export const LIST_TRANS_PLAN_TRAVEL = gql`
query ListTransPlanTravel($planDate:String!, $dcCd:String) {
    transPlanTravelList(planDate:$planDate, dcCd:$dcCd) {
        planId
        planDate
        dcCd
        dcName
        comId
        comName
        vehPlates
        bindGroupNo
        bindOrder
        driverName
        driverMobile
        rentYn
        timeDeparture
        storeId
        storeName
        hocha
        prosDptrTime
        prosArrTime
        timeArrival
        dischStartKeyTime
        storeKeyDptrTime
        regDate
        regUser
    }
}
`;

/**
 * 동적, 독적 목록을 받아서 그룹별로 묶어서 리턴한다.
 * 동적은 그룹화하고, 독적은 planId로 그 자체가 그룹인것처럼 처리한다.
 * @param {*} list transPlanTravelList result
 * @returns 
 */
export function reformTransPlanTravelList(list) {
    // Key: planId.
    // group by bindGroupNo, order in the group by bindOrder.
    // common: planId, planDate, dcCd, dcName, comId, comName, vehPlates, driverName, driverMobile, rentYn, timeDeparture
    // prosDptrTime, -- DC 출발예상 시간
    // prosArrTime, -- Store 도착예상 시간
    // timeArrival, -- 점포도착(Confirmed) 시간
    // Not used: dischStartKeyTime, storeKeyDptrTime, regDate, regUser
    const map = {};
    list.forEach(item=>{
        const {
            planId, planDate, dcCd, dcName, comId, comName, vehPlates,
            bindGroupNo, bindOrder, driverName, driverMobile, rentYn, timeDeparture,
            storeId, storeName, hocha, prosDptrTime, prosArrTime, timeArrival
        } = item;
        const groupKey = bindGroupNo ? `g${bindGroupNo}` : `p${planId}`;

        if(!map[groupKey]) {
            map[groupKey] = {
                planId, planDate, dcCd, dcName, comId, comName, vehPlates,
                driverName, driverMobile, rentYn, timeDeparture,
                nodes: []
            };
        }
        map[groupKey].nodes.push({
            storeId, storeName, hocha, prosDptrTime, prosArrTime, timeArrival, bindOrder
        });
    });
    return Object.values(map).sort((a,b)=>a.vehPlates-b.vehPlates);
}

function includeInText(text, search) {
    if(text) {
        return text.includes(search);
    }
    return false;
}

export function transPlanTravelInclude(item, searchText) {
    if(IsValid.nullString(searchText)) return true;
    if(
        includeInText(item.comName, searchText) ||
        includeInText(item.vehPlates, searchText) ||
        includeInText(item.driverName, searchText) ||
        includeInText(item.driverMobile, searchText)
    ) return true;

    for(const node of item.nodes) {
        if(
            includeInText(node.storeName, searchText) ||
            includeInText(node.storeId, searchText)
        ) return true;
    }
    return false;
}